import React, { Fragment, useEffect, useState } from 'react';
import SelectProducts from './SelectProducts';
import Close from '../../../../../Assets/Modals/closeIcon.svg';
import ImageAdd from '../../../../../Assets/Modals/ImageAdd.svg';
import RupeeGray from '../../../../../Assets/Modals/RupeeGray.svg';
import ChevronDown from '../../../../../Assets/Modals/ChevronDown.svg';
import ProductColorsAndSizes from './ProductColorsAndSizes';

import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers";
import { CalendarIcon } from '@mui/x-date-pickers';
import { closeModal, setActionAlert, setActiveSection } from '../../../../../Features/dropTrackProductsSlice';
import { useDispatch, useSelector } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import { createBundle } from '../../../../../lib/utils/apiCalls';
import { formatDate } from '../../../../../lib/utils/utils';
import { showToast } from '../../../../../Components/Toaster/Toaster';

const taxCodes = [
    // { id: "GST_3", label: "GST_3" },
    { id: "GST_5", label: "GST_5" },
    // { id: "GST_15", label: "GST_12" },
    { id: "GST_18", label: "GST_18" },
    { id: "GST_40", label: "GST_40" },
    // { id: "GST_Apprael", label: "GST_Apprael" },
];

function CreateBundleOffer() {
    const dispatch = useDispatch();

    const [selectedProducts, setSelectedProducts] = useState([]);

    const selectedProductVariants = useSelector((state) => state.dropTrackAction.selectedProductVariants);

    const defaultFormErrors = {
        bundleName: '',
        bundleDescription: '',
        price: '',
        hsnCode: '',
        taxCode: '',
        country: '',
        variants: '',
        date: '',
    };

    const defaultFormFields = {
        bundleName: '',
        bundleDescription: '',
        price: '',
        hsnCode: '',
        taxCode: '',
        country: '',
    };
    
    const [formErrors, setFormErrors] = useState(defaultFormErrors);
    const [formInputs, setFormInputs] = useState(defaultFormFields);

    const dates = {
        from: null,
        to: null,
    }

    const [date, setDate] = useState(dates);
    const [images, setImages] = useState([]);
    const [isOpen, setIsOpen] = useState(false);

    const changeHandler = (e) => {
        const { name, value } = e.target;
        setFormInputs({...formInputs, [name]: value});
    }

    const handleTaxSelect = (value) => {
        setFormInputs({...formInputs, 'taxCode': value});
        setIsOpen(false);
    }

    const toggleDropdown = (e) => {
        e.preventDefault();
        setIsOpen(!isOpen);
    }

    const handleProductsSelection = (list) => {
        setSelectedProducts(list);
    };

    const handleButtonClick = () => {
        dispatch(closeModal());
    };

    const handleImageSelection = (e) => {
        const files = Array.from(e.target.files);

        if(images.length + files.length <= 10) {
            const selectedImages = files.map(file => ({
                id: uuidv4(),
                url: URL.createObjectURL(file),
            }));

            if (files.length > 1) {
                setImages([ ...selectedImages ]);
            }
            else {
                setImages([ ...images, selectedImages[0] ])
            }
        }
        else {
            alert('Max 10 images');
        }
    };

    const handleResponse = async (response) => {
        // eslint-disable-next-line eqeqeq
        if (response.statusCode == 10000) {
            showToast('Create bundle succcessful!', 'success');
            dispatch(closeModal());
            dispatch(setActionAlert({
                type: 'Create Bundle',
                startDate: formatDate(response.data.startDate),
                endDate: formatDate(response.data.endDate),
            }));
            dispatch(setActiveSection('insights'));
        }
    };

    const handleNotifyButton = async () => {
        const validationErrors = {};

        const fromDate = new Date(date.from);
        const toDate = new Date(date.to);

        const fromTimestamp = fromDate.getTime();
        const toTimestamp = toDate.getTime();

        if(!formInputs.bundleName.trim()) {
            validationErrors.bundleName = 'Bundle Name is required';
        }

        if(!formInputs.bundleDescription.trim()) {
            validationErrors.bundleDescription = 'Bundle Description is required';
        }

        if(!formInputs.price.trim()) {
            validationErrors.price = 'Required field';
        }

        if(!formInputs.hsnCode.trim()) {
            validationErrors.hsnCode = 'Required field';
        }

        if(!formInputs.taxCode.trim()) {
            validationErrors.taxCode = 'Required field';
        }

        if(selectedProductVariants.length === 0) {
            validationErrors.variants = 'Minimum 1 variant required';
        } 

        if(!formInputs.country.trim()) {
            validationErrors.country = 'Required field';
        }

        if(fromTimestamp || toTimestamp) {
            if(!fromTimestamp) {
                validationErrors.date = 'Select Start Date';
            }
            else if(!toTimestamp) {
                validationErrors.date = 'Select End Date';
            }
            else if(fromDate > toDate) {
                validationErrors.date = 'Start date should be earlier than End date';
            }
        }

        if(Object.keys(validationErrors).length === 0) {
            const callData = {
                bundleName: formInputs.bundleName,
                bundleDesc: formInputs.bundleDescription,
                bundlePrice: formInputs.price,
                productVarientIds: selectedProductVariants.map(variant => variant.id),
                HSNCode: formInputs.hsnCode,
                TaxCode: formInputs.taxCode,
                country: formInputs.country,
            };

            if(fromTimestamp && toTimestamp) {
                try {
                    const response = await createBundle(
                        {
                            ...callData,
                            startDate: fromDate.toISOString(),
                            endDate: toDate.toISOString()
                        }
                    );
                    await handleResponse(response);
                }
                catch (err) {
                    showToast(`Error occurred`, 'error');
                }
            }
            else {
                try {
                    const response = await createBundle(callData);
                    await handleResponse(response);
                }
                catch (err) {
                    showToast(`Error occurred`, 'error');
                }
            }
        }
        else {
            setFormErrors(validationErrors);
            return;
        }
    }

    useEffect(() => {
        const array = selectedProducts.map(item => ({
            id: uuidv4(),
            url: item.product.productImgUrls[0],
        }));
        setImages(array);
    }, [selectedProducts]);

    return (
        <Fragment>
            {
                !selectedProducts.length ? 
                <SelectProducts 
                    setProductsList={val => handleProductsSelection(val)} 
                /> : 
                <div className="w-[91%] h-[90%] bg-[#FFFFFF] rounded-xl overflow-hidden p-6 flex flex-col gap-3 relative">
                    <div className="flex items-center justify-between">
                        <h1 className='font-urbanist-regular font-semibold text-2xl text-[#121212]'>Create Bundle Offer</h1>

                        <button onClick={handleButtonClick}>
                            <img src={Close} alt="Close Modal" />
                        </button>
                    </div>

                    <form className="flex flex-col gap-3 max-h-full overflow-y-scroll pr-1 pb-20">
                        <div className="flex flex-col gap-2">
                            <div className="flex items-center justify-between">
                                <label className='m-0 font-urbanist-regular font-medium text-base text-[#000000]' htmlFor="name-input">
                                    Product Name
                                </label>

                                {formErrors.bundleName && <p className='text-[14px] leading-5 text-[#DC2626]'>{formErrors.bundleName}</p>}
                            </div>

                            <div className="h-14 bg-[#F5F5F5] px-2 py-[6px] rounded-lg border border-[#EAEAEA] flex items-center justify-center">
                                <input 
                                    name='bundleName' 
                                    onChange={changeHandler} 
                                    placeholder='Enter product name' 
                                    className='w-full bg-transparent outline-none border-none text-sm font-medium placeholder:text-[#666666]' 
                                    type="text" 
                                />
                            </div>
                        </div>

                        <div className="flex flex-col gap-3">
                            <label className='m-0 font-urbanist-regular font-medium text-base text-[#000000]' htmlFor="name-input">
                                Add Image
                            </label>

                            <div className="p-3 flex flex-wrap gap-[6px] bg-[#F5F5F5] rounded-xl">
                                <label htmlFor='image-input' className="m-0 cursor-pointer flex flex-col items-center justify-center gap-[10px] w-[140px] h-[140px] bg-[#E5E5E5] px-5 py-[10px] border-2 border-dashed border-[#D1D5DB] rounded-lg">
                                    <div className="w-12 h-12 flex justify-center items-center">
                                        <img src={ImageAdd} alt="" />
                                    </div>

                                    <p className='font-urbanist-regular font-medium text-sm text-[#4B5563]'>
                                        <span className='text-[#4F46E5]'>Click to Upload</span> or Drag or drop
                                    </p>
                                </label>

                                <input 
                                    className='hidden' 
                                    id='image-input' 
                                    type="file" 
                                    accept="image/*" 
                                    multiple
                                    onChange={handleImageSelection}
                                />

                                {images.map(img => {
                                    return (
                                        <div 
                                            key={img.id} 
                                            className="w-[140px] h-[140px] rounded-lg bg-center bg-no-repeat bg-cover" 
                                            style={{
                                                backgroundImage: `url(${img.url})` 
                                            }}
                                        />
                                    )
                                })}
                            </div>
                        </div>

                        <div className="flex flex-col gap-2">
                            <div className="flex items-center justify-between">
                                <label className='m-0 font-urbanist-regular font-medium text-base text-[#000000]'>
                                    Product Description
                                </label>

                                {formErrors.bundleDescription && <p className='text-[14px] leading-5 text-[#DC2626]'>{formErrors.bundleDescription}</p>}
                            </div>

                            <div className="h-40 bg-[#F5F5F5] px-3 py-4 rounded-lg border border-[#EAEAEA] flex items-center justify-center">
                                <textarea 
                                    onChange={changeHandler}
                                    name='bundleDescription' 
                                    placeholder='Enter product description' 
                                    className='w-full h-full bg-transparent outline-none border-none text-sm font-medium placeholder:text-[#666666]' 
                                    type="text" 
                                />
                            </div>
                        </div>

                        <div className="flex flex-col gap-4">
                            <h1
                                className="m-0 font-urbanist-regular font-medium text-base text-[#000000]"
                                htmlFor="name-input"
                            >
                                Price and Taxes
                            </h1>

                            <div className="grid grid-cols-4 gap-x-2">
                                {/* Promotional Price */}
                                <div className="flex flex-col gap-2">
                                    <div className="flex items-center justify-between">
                                        <label className='m-0 font-urbanist-regular font-medium text-base text-[#000000]' htmlFor="price-input">
                                            Promotional Price
                                        </label>

                                        {formErrors.price && <p className='text-[14px] leading-5 text-[#DC2626]'>{formErrors.price}</p>}
                                    </div>

                                    <div className="h-14 bg-[#F5F5F5] px-2 py-[6px] rounded-lg border border-[#EAEAEA] flex items-center gap-1">
                                        <div className="w-6 h-6 flex items-center justify-center">
                                            <img src={RupeeGray} alt="Rupee" />
                                        </div>

                                        <input 
                                            name='price' 
                                            onChange={changeHandler} 
                                            className='bg-transparent outline-none border-none text-sm font-medium placeholder:text-[#666666]' 
                                            id='price-input' 
                                            placeholder='0.00' 
                                            type="number" 
                                        />
                                    </div>
                                </div>

                                {/* HSN Code */}
                                <div className="flex flex-col gap-2">
                                    <div className="flex items-center justify-between">
                                        <label className='m-0 font-urbanist-regular font-medium text-base text-[#000000]' htmlFor="hsnCode">
                                            HSN Code
                                        </label>

                                        {formErrors.hsnCode && <p className='text-[14px] leading-5 text-[#DC2626]'>{formErrors.hsnCode}</p>}
                                    </div>

                                    <div className="h-14 bg-[#F5F5F5] px-2 py-[6px] rounded-lg border border-[#EAEAEA] flex items-center justify-center">
                                        <input 
                                            id='hsnCode'
                                            name='hsnCode' 
                                            onChange={changeHandler} 
                                            placeholder='Enter HSN code' 
                                            className='w-full bg-transparent outline-none border-none text-sm font-medium placeholder:text-[#666666]' 
                                            type="text" 
                                        />
                                    </div>
                                </div>

                                {/* Select Tax Code */}
                                <div className="flex flex-col gap-2 relative">
                                    <div className="flex items-center justify-between">
                                        <label className='m-0 font-urbanist-regular font-medium text-base text-[#000000]'>
                                            Select Tax Code
                                        </label>

                                        {formErrors.taxCode && <p className='text-[14px] leading-5 text-[#DC2626]'>{formErrors.taxCode}</p>}
                                    </div>

                                    <button onClick={toggleDropdown} className="outline-none h-14 px-3 py-4 bg-[#F5F5F5] border border-[#EAEAEA] rounded-[9px] flex items-center justify-between">
                                        <p className='text-[#666666] font-urbanist-regular font-normal text-base'>
                                            {!formInputs.taxCode.length ? 'select tax code' : formInputs.taxCode}
                                        </p>

                                        <div className="flex items-center justify-center">
                                            <img src={ChevronDown} alt="Dropdown" />
                                        </div>
                                    </button>

                                    {/* Dropdown List */}
                                    {isOpen && 
                                        <ul className="w-full absolute top-[88px] right-0 border border-[#EAEAEA] shadow-[0px_3px_6px_0px_#0000001F] rounded-xl overflow-hidden">
                                            {taxCodes.map(code => {
                                                return (
                                                    <li key={code.id} onClick={() => handleTaxSelect(code.label)} className='cursor-pointer px-3 py-4 bg-[#FFFFFF]'>{code.label}</li>
                                                );
                                            })}
                                        </ul>
                                    }
                                </div>

                                {/* Country */}
                                <div className="flex flex-col gap-2">
                                    <div className="flex items-center justify-between">
                                        <label className='m-0 font-urbanist-regular font-medium text-base text-[#000000]' htmlFor="country-input">
                                            Country
                                        </label>

                                        {formErrors.country && <p className='text-[14px] leading-5 text-[#DC2626]'>{formErrors.country}</p>}
                                    </div>

                                    <div className="h-14 bg-[#F5F5F5] px-2 py-[6px] rounded-lg border border-[#EAEAEA] flex items-center justify-center">
                                        <input 
                                            id='country-input' 
                                            name='country' 
                                            onChange={changeHandler} 
                                            placeholder='Enter country' 
                                            className='w-full bg-transparent outline-none border-none text-sm font-medium placeholder:text-[#666666]' 
                                            type="text" 
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="flex flex-col gap-3 mt-2">
                            <div className="font-urbanist-regular flex flex-col gap-1">
                                <div className="flex items-center justify-between">
                                    <h1 className='font-medium text-[16px] leading-[22px] text-[#121212]'>Product Variants</h1>

                                    {formErrors.variants && <p className='text-[14px] leading-5 text-[#DC2626]'>{formErrors.variants}</p>}
                                </div>

                                <p className='font-normal text-[12px] leading-5 text-[#666666]'>All variants are initially selected for your convenience. Should any variant not fit your bundle vision, simply unselect it to tailor your offer precisely.</p>
                            </div>

                            <div className="flex flex-col gap-3">
                                {selectedProducts.map(item => {
                                    return (
                                        <ProductColorsAndSizes 
                                            key={item.product.id} 
                                            product={item} 
                                        />
                                    );
                                })}
                            </div>
                        </div>

                        <div className="flex flex-col gap-[14px] font-urbanist-regular">
                            <div className="flex flex-col gap-2 font-urbanist-regular">
                                <div className="flex items-center justify-between">
                                    <h1 className='font-medium text-[16px] leading-8 text-[#121212]'>
                                        Set Duration 
                                        &#40;optional&#41;
                                    </h1>

                                    {formErrors.date && <p className='text-[14px] leading-5 text-[#DC2626]'>{formErrors.date}</p>}
                                </div>
                            
                                <p className='font-medium text-[16px] leading-[28px] text-[#666666]'>Specify your deal's duration and let the system automatically expire to bundle offer after promotional period.</p>
                            </div>

                            <div className="flex gap-8 text-black font-urbanist-regular">
                                <div className="flex flex-col gap-1">
                                    <h1 className='font-normal text-base'>From</h1>

                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DemoContainer components={['DatePicker']}>
                                            <DatePicker
                                                label="Start Date" 
                                                onChange={e => setDate({ ...date, from: e.$d })} 
                                                slots={{ openPickerIcon: CalendarIcon }} 
                                                sx={{
                                                    width: '180px'
                                                }}
                                            />
                                        </DemoContainer>
                                    </LocalizationProvider>
                                </div>

                                <div className="flex flex-col gap-1">
                                    <h1 className='font-normal text-base'>To</h1>

                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DemoContainer components={['DatePicker']}>
                                            <DatePicker
                                                label="End Date" 
                                                onChange={e => setDate({ ...date, to: e.$d })} 
                                                slots={{ openPickerIcon: CalendarIcon, }} 
                                                sx={{
                                                    width: '180px',
                                                }}
                                            />
                                        </DemoContainer>
                                    </LocalizationProvider>
                                </div>
                            </div>
                        </div>
                    </form>

                    <div className="bg-[#FFFFFF] z-10 absolute w-full right-0 bottom-0 flex items-center justify-between p-6 shadow-[-9px_0px_18px_0px_#00000033]">
                        <p className='font-urbanits-regular font-normal text-[14px] leading-[22px] text-[#121212]'>
                            Note: This bundle offer only visible to DropTrack Watchers and It will be added to the new custom collections <span className='font-bold'>“DropTrack Bundles”</span>
                        </p>

                        <button onClick={handleNotifyButton} className='whitespace-nowrap px-4 py-2 rounded font-urbanist-regular font-semibold text-base text-center bg-primaryColor hover:bg-primaryAccent text-buttonText' type='button'>
                            Notify DropTrack Watchers
                        </button>
                    </div>
                </div>
            }
        </Fragment>
    );
}

export default CreateBundleOffer;
